export default {
  "airdropConfig.title": "Airdrop Config",
  "airdropConfig.column.no": "#NO",
  "airdropConfig.column.taskId": "TaskId",
  "airdropConfig.column.title": "Title",
  "airdropConfig.column.amount": "CashScope",
  "airdropConfig.column.scopeDesc": "UserScope",
  "airdropConfig.column.enable": "Status",
  "airdropConfig.column.typeDesc": "Type",
  "airdropConfig.column.statusDesc": "Repeat",
  "airdropConfig.column.createTime": "CreateTime",
  "airdropConfig.column.pushTime": "PushTime",
  "airdropConfig.column.action": "Action",
  "airdropConfig.action.delete": "Delete",
  "airdropConfig.action.start": "StartTask",
  "airdropConfig.action.stop": "StopTask",
  "airdropConfig.action.details": "Details",
  "airdropConfig.action.edit": "Edit",
  "airdropConfig.form.title": "Title",
  "airdropConfig.form.type": "Type",
  "airdropConfig.form.type.once": "OnceTask",
  "airdropConfig.form.type.fixed": "FixedTask",
  "airdropConfig.form.scopeType": "Scope",
  "airdropConfig.form.scopeType.recharge": "Recharge in the last few days",
  "airdropConfig.form.scopeType.designated": "Designated User",
  "airdropConfig.form.pushTime": "PushTime",
  "airdropConfig.form.pushTime.start": "Start Time",
  "airdropConfig.form.pushTime.end": "End Time",
  "airdropConfig.form.usernoList": "User Numbers",
  "airdropConfig.form.usernoList.placeholder": "Please enter user numbers, comma separated",
  "airdropConfig.form.depositNearDays": "Deposit Near Days",
  "airdropConfig.form.depositNearDays.placeholder": "Enter days",
  "airdropConfig.form.day": "day",
  "airdropConfig.form.probabilityList": "Cash Config",
  "airdropConfig.form.probabilityList.required": "Please add at least one cash config",
  "airdropConfig.form.amount": "Amount",
  "airdropConfig.form.amount.placeholder": "Enter amount",
  "airdropConfig.form.probability": "Probability",
  "airdropConfig.form.probability.placeholder": "Enter probability",
  "airdropConfig.form.probabilityTotal.error": "The sum of all probabilities must equal 100%",
  "airdropConfig.confirm.delete.title": "Delete Airdrop Task",
  "airdropConfig.confirm.delete.content": "Are you sure you want to delete this airdrop task?",
  "airdropConfig.confirm.start.title": "Start Task",
  "airdropConfig.confirm.start.content": "Are you sure you want to start this task?",
  "airdropConfig.confirm.stop.title": "Stop Task",
  "airdropConfig.confirm.stop.content": "Are you sure you want to stop this task?",
  "airdropConfig.confirm.ok": "Confirm",
  "airdropConfig.confirm.cancel": "Cancel",
  "airdropConfig.add": "New Task",
  "airdropConfig.edit": "Edit",
  "airdropConfig.status.start": "Start",
  "airdropConfig.status.stop": "Stop",
  "airdropConfig.modal.add.title": "Add Airdrop Task",
  "airdropConfig.modal.details.title": "Airdrop Task Details",
  "airdropConfig.modal.edit.title": "Edit Airdrop Task",
};

